import { sendTokenToExtension } from "@/helpers/send-to-extension.ts";
import { queryClient } from "@/queryClient.ts";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { useAuthStore } from "@/stores/employee.store.ts";
import { Button, EmptyStateBase } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEffectOnce } from "react-use";

const domain = import.meta.env.VITE_DOMAIN;
const app_name = import.meta.env.VITE_APP_NAME;

export default function EmptyStateInactivePlan() {
  const { t } = useTranslation();
  const { setToken } = useAuthStore();
  const navigate = useNavigate();

  const logout = () => {
    queryClient.clear();
    setToken(null);
    sendTokenToExtension(null);
    navigate("/login");
  };

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.planInactiveViewed);
  });

  return (
    <EmptyStateBase
      emoji={":shrug:"}
      title={t("errors:plan_inactive_title")}
      description={t("errors:plan_inactive_description", {
        app_name: app_name,
        email: `support@${domain}`,
      })}
      primaryButton={
        <Button variant={"secondary"} onClick={logout}>
          {t("common:logout")}
        </Button>
      }
    />
  );
}
